const pad = (n: number) => String(n).padStart(2, '0');

// YYYY-MM-DD HH:MM, in local time
export const formatDateTime = (d: Date) =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} `
  + `${pad(d.getHours())}:${pad(d.getMinutes())}`;
